import {AppImpl} from '../App';
import {STPTwilioIframe} from './STPTwilioIframe';
import {useApp} from '../hooks/appHooks';

export function AppLiveChatIframe() {
  const app = useApp() as AppImpl;
  return <STPTwilioIframe app={app} chatClient={app.chatClient} />;
}
